export default "__VITE_ASSET__4wmXuR5W__"